var map = {
	"./html": 458,
	"./html.js": 458,
	"./json": 464,
	"./json.js": 464,
	"./md": 465,
	"./md.js": 465,
	"./toml": 466,
	"./toml.js": 466,
	"./yaml": 468,
	"./yaml.js": 468
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;



//////////////////
// WEBPACK FOOTER
// ../wrappers ^\.\/.*$
// module id = 457
// module chunks = 0